import { Controller } from 'stimulus'

export default class HeroanimationController extends Controller {
  connect() {
    this.onPageScrollBind = this.onPageScroll.bind(this)
    window.addEventListener("scroll", this.onPageScrollBind)
  }

  disconnect() {
    window.removeEventListener("scroll", this.onPageScrollBind)
  }

  onPageScroll() {
    if (window.scrollY < 30) {
      this.element.style.backgroundColor = `rgba(255, 255, 255, 0)`
      return
    }

    const height = (window.scrollY / this.element.getBoundingClientRect().height) * 10
    if (height / 10 <= 0.5) {
      this.element.style.backgroundColor = `rgba(255, 255, 255, ${height / 10})`
    } else {
      this.element.style.backgroundColor = `rgba(255, 255, 255, 0.5)`
    }
  }
}